import React from "react";
import { useSelector } from "react-redux";

import { GameInformationConceptDetailsDataType } from "../../../../models/forms";
import { getGenres } from "../../../../redux/selectors";
import { FieldOption } from "../../../../server/crm/api/models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxConceptDetailProps = {
  dataInForm: GameInformationConceptDetailsDataType;
};

const IdXboxConceptDetailConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["gameTitle", {}],
  ["codeName", {}],
  [
    "genre",
    {
      mapper: (
        data: GameInformationConceptDetailsDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const crmGenresList = additionalData.get("crmGenresList") as FieldOption[];
        return crmGenresList.find(genreItem => genreItem.id === data.genre)?.value;
      },
    },
  ],
  [
    "gameDevelopers",
    {
      title: "gameDeveloper",
    },
  ],
  [
    "hook",
    {
      title: "theHook",
    },
  ],
  [
    "gameplayVideosLinks",
    {
      title: "gameplayVideo",
    },
  ],
  [
    "gameplayDetails",
    {
      title: "gameplayDetailsAndSummary",
    },
  ],
  [
    "gameplayDuration",
    {
      title: "gameplayDurationReadOnlyTitle",
    },
  ],
  ["levelsDetails", {}],
  ["levelsNumber", {}],
  ["steamLink", {}],
  ["itchIoLink", {}],
  ["gameBuildLinks", {}],
  ["gameBuildKeys", {}],
  [
    "additionalLinks",
    {
      isAnswerWithHtmlContent: true,
    },
  ],
]);

export const ReadOnlyIdXboxConceptDetail = ({ dataInForm }: ReadOnlyIdXboxConceptDetailProps) => {
  const crmGenresList = useSelector(getGenres);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["crmGenresList", crmGenresList]]);
  return (
    <ReadOnlyForm
      formConfig={IdXboxConceptDetailConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
